const setupMegaMenu = (navLinkId, megaMenuId, navIconId, stickyHoverClass, stickyIconClass) => {
    let timeoutId;

    const hoverTarget = document.getElementById(navLinkId);
    const hoverContent = document.getElementById(megaMenuId);
    const hoverIcon = document.getElementById(navIconId);

    const showContent = () => {
        clearTimeout(timeoutId);
        hoverContent.style.visibility = 'visible';
        hoverContent.style.opacity = 1;
        hoverTarget.classList.add(stickyHoverClass);
        hoverIcon.classList.add(stickyIconClass);
    };

    const hideContent = () => {
        timeoutId = setTimeout(() => {
            hoverContent.style.visibility = 'hidden';
            hoverContent.style.opacity = 0;
            hoverTarget.classList.remove(stickyHoverClass);
            hoverIcon.classList.remove(stickyIconClass);
        }, 50);
    };

    hoverTarget.addEventListener('mouseenter', showContent);
    hoverTarget.addEventListener('mouseleave', hideContent);
    hoverContent.addEventListener('mouseenter', showContent);
    hoverContent.addEventListener('mouseleave', hideContent);
};
setupMegaMenu('nav-linkID-2', 'collection-megaMenu', 'nav-iconID-2', 'sticky--hover-2', 'sticky--icon-2');
setupMegaMenu('nav-linkID-1', 'store-megaMenu', 'nav-iconID-1', 'sticky--hover-1', 'sticky--icon-1');

// Mobile side menu navigation (Close & Open)
function openNav() {
    document.getElementById("navigation-mobile-drawer").style.transform = "translate(0)";
    document.getElementById("navigation-mobile-drawer").style.padding = "0px 16px";
    document.getElementById("sidenav__darklayer").style.display = "block";
}  
function closeNav() {
    document.getElementById("navigation-mobile-drawer").style.transform = "translate(-100%)";
    document.getElementById("navigation-mobile-drawer").style.padding = "0px";
    document.getElementById("sidenav__darklayer").style.display = "none";
}


// Mobile Menu Navigation Code for Dropdown menus
document.querySelectorAll('.dropdown-btn').forEach(button => {
    button.addEventListener('click', () => {
      const dropdown = button.parentElement.parentElement;
      dropdown.classList.toggle('active');
    });
});